import { installClientHeaderInterceptor } from "@/lib/clientHeader";

// Task #993: bootstrap-only side-effect module. Importing this from
// `client/src/main.tsx` as the very first import patches `window.fetch`
// before any other module's top-level code runs. Keep this file
// import-light — it must not depend on application code that could in
// turn issue a top-level fetch.
installClientHeaderInterceptor();
